import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Get build version for cache busting
const getVersion = () => {
  // Use React build-time environment variable + timestamp for stronger cache busting
  return process.env.REACT_APP_VERSION || "1.0.1";
};

// Get build timestamp for cache busting (set at build time)
const getBuildTime = () => {
  return process.env.REACT_APP_BUILD_TIME || Date.now();
};

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // Add cache busting to translation file requests using version + build time
      loadPath: `/locales/{{lng}}/translation.json?v=${getVersion()}&t=${getBuildTime()}`,
      // Parse response
      parse: function (data) {
        return JSON.parse(data);
      },
    },
    fallbackLng: "de",
    debug: process.env.NODE_ENV === "development",

    detection: {
      // Order of language detection - localStorage first, then browser
      order: ["localStorage", "navigator", "htmlTag"],
      // Cache user language preference in localStorage
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
